export default "__VITE_ASSET__5GmFL9R2__"